import * as styles from 'styles/atoms/tables/PaginatorArrow.css'
import * as cn from 'classnames'
import { QAMarked } from 'interfaces/component'

type PaginatorArrowStateProps = {
  direction: 'left' | 'right'
  kind: 'single' | 'double'
  disabled?: boolean
}

type PaginatorArrowDispatchProps = QAMarked & {
  onClick: () => void
}

type PaginatorArrowProps = PaginatorArrowStateProps & PaginatorArrowDispatchProps

const PaginatorArrow = ({ direction, disabled, kind, onClick, qaMarker, qaType }: PaginatorArrowProps) => {
  const isDouble = kind === 'double'

  const rootClass = cn(styles.paginatorArrow, {
    [styles.disabled]: disabled,
    [styles.right]: direction === 'right',
    [styles.double]: isDouble,
  })

  return (
    <button className={ rootClass } disabled={ disabled } onClick={ onClick } data-qa-marker={ qaMarker } data-qa-type={ qaType }>
      <div className={ styles.strokes } />
      { isDouble ? <div className={ styles.strokes } /> : null }
    </button>
  )
}

export default PaginatorArrow
